module.exports = __webpack_public_path__ + "/images/shop/footer/norton_security.jpg";